<template>
  <div id="Certification">
    <v-card class=" mt-2 mb-5 " style="borderRadius:5px" id="buttonShadow">
      <v-card-title class="pa-0">
              <v-layout class="grey lighten-3" align-center>
                <v-layout class="grey lighten-3" py-2 align-center>

                  <p class="subtitle-1 font-weight-medium ml-2 mb-0 blue--text text--darken-3">{{certification.certification_type}}</p>  <span class=" caption "> <span class="ml-1">- EXP</span> {{certification.expiration_date | moment(" MM/DD/YYYY")}}</span>

                </v-layout>

                <v-spacer></v-spacer>

                    <v-icon @click="editCertification(certification.id)" class="mr-2">mdi-pencil</v-icon>
                    <RemoveCertification :certification="certification"/>

              </v-layout>
          </v-card-title>

    </v-card>
  </div>
</template>

<script>
export default {
   props: ['certification'],
  data() {
    return {

    }
  },
  methods: {
    editCertification (id) {
       this.$router.push('/dashboard/healthcarehours/editcertification/' + id)
    }
  }
}
</script>

<style scoped>
  #buttonShadow {
    box-shadow: 0 10px 20px -5px rgba(0,0,0,.19);
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/Certifications/Certification.vue